import { Button, Group, Modal, Textarea, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import axios from "axios";
import { useEffect } from "react";
import { toast } from "react-hot-toast";
import AddressFinder from "@/components/AddressFinder";
import useAuthStore from "@/store/useAuthStore";

export default function DetailModal({ mutate, item, id, title }) {
  const user = useAuthStore((state) => state.user);
  const [opened, { open, close }] = useDisclosure();

  const isNew = !item;
  const label = isNew ? `${title} 등록` : `${title} 수정`;

  const form = useForm({
    initialValues: {
      name: "",
      address: "",
      addressDetail: "",
      lat: "",
      lng: "",
      managerName: "",
      managerPhoneNumber: "",
      type: "",
      company: "",
      memo: "",
    },
  });

  async function handleSubmit(data) {
    if (isNew) {
      await axios({
        url: "/partners",
        method: "POST",
        data: {
          data: {
            ...data,
            lat: parseFloat(data.lat),
            lng: parseFloat(data.lng),
            company: user?.company?.id,
            type: "unload",
          },
        },
      });
      form.reset();
    } else {
      await axios({
        url: `/partners/${id}`,
        method: "PUT",
        data: {
          data: {
            ...data,
            lat: parseFloat(data.lat),
            lng: parseFloat(data.lng),
            company: user?.company?.id,
            type: "unload",
          },
        },
      });
    }

    mutate();
    toast.success(`${label} 처리 완료`);
    close();
  }

  async function handleDelete() {
    await axios({
      url: `/partners/${id}`,
      method: "DELETE",
    });
    mutate();
    toast.success("삭제 완료");
    close();
  }

  useEffect(() => {
    if (item) {
      form.setValues({
        ...item,
        memo: item.memo || "",
        company: item.company ? item.company?.data?.id : "",
      });
    }
  }, [item]);

  return (
    <>
      <Button onClick={open} compact={!isNew}>
        {isNew ? label : "관리"}
      </Button>

      <Modal opened={opened} onClose={close} title={label}>
        <form onSubmit={form.onSubmit(handleSubmit)}>
          {/* <Select
            label="소속 업체"
            required
            placeholder="소속 업체를 선택해주세요"
            {...form.getInputProps("company")}
            data={companyList.map((company) => ({ value: company.id, label: company?.attributes?.name }))}
            mb="sm"
          /> */}

          <TextInput
            label="거래처명"
            required
            placeholder="거래처명을 입력해주세요"
            {...form.getInputProps("name")}
            mb="sm"
          />

          <AddressFinder
            title="거래처 주소"
            address={form.values.address}
            setAddress={(value) => form.setFieldValue("address", value)}
            setLat={(value) => form.setFieldValue("lat", value)}
            setLng={(value) => form.setFieldValue("lng", value)}
          />

          <TextInput
            label="거래처 세부주소"
            placeholder="거래처 세부주소를 입력해주세요"
            {...form.getInputProps("addressDetail")}
            mb="sm"
            mt="sm"
          />

          <TextInput
            label="담당자명"
            required
            placeholder="담당자명을 입력해주세요"
            {...form.getInputProps("managerName")}
            mb="sm"
          />

          <TextInput
            label="담당자 전화번호"
            required
            placeholder="담당자 전화번호를 입력해주세요"
            {...form.getInputProps("managerPhoneNumber")}
            mb="sm"
          />

          <Textarea
            label="메모/특이사항"
            placeholder="메모/특이사항을 입력해주세요"
            {...form.getInputProps("memo")}
            mb="sm"
          />

          <Group mt="lg">
            <Button color="red" disabled={isNew} onClick={handleDelete}>
              삭제
            </Button>
            <Button type="submit">{label}</Button>
          </Group>
        </form>
      </Modal>
    </>
  );
}
